import { addImageView } from '@core/utils'
import React from 'react'
import style from './style.module.less'

const ScrollImgs = ({ imgs }) => {
  return (
    <div className={style.scrollImage}>
      <ul className={style.imgBox}>
        {!imgs?.length && (
          <li className={style.empty}>
            <img
              width="48"
              height="48"
              src="https://qnm.hunliji.com/FvGu36HMmuXyHHWJlSsmPto0Wot3"
            />
            <span>暂无图片</span>
          </li>
        )}
        {imgs?.map((item, index) => (
          <li key={index} className={style.imgItem}>
            <img width="144" height="90" src={addImageView(item?.url, 400)} />
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ScrollImgs
